<template>
  <div class="mb-5">
    <b-row>
      <b-col cols="10">
        <h4 class="row-dash-title">Expurgo - Tempo de processamento</h4>
      </b-col>
      <b-col cols="2">
        <div v-if="loadingExport || loading" class="float-right">
          <b-spinner class="load-icon"/>
        </div>
        <div @click="exportData" v-else clas="float-right">
          <external-link-icon
            style="cursor:pointer"
            size="1.5x"
            v-b-tooltip.hover.right="'Exportar dados'"
          />
        </div>
      </b-col>
    </b-row>
    <b-overlay
      :show="loading"
      rounded="sm"
      class="dashboard-overlay"
    >
      <div class="dash-box">
        <ECharts :option="chartExpurgoMensal" />
      </div>
    </b-overlay>
  </div>
</template>

<script>
import moment from 'moment';
import ECharts from 'vue-echarts';

import GenericApi from '../../../services/genericRequest';

export default {
  name: 'TempoProcesExpurgoMensal',
  components: {
    ECharts,
  },

  inject: ['getExportedData', 'createXlsx'],

  props: {
    unidadeIndicadores: {
      type: Number,
      required: true,
    },
    date: {
      type: Object,
      required: true,
    },
  },

  watch: {
    unidadeIndicadores: {
      deep: true,
      handler() {
        this.updateChart();
      },
    },
    date: {
      deep: true,
      handler(d) {
        this.selectedMonth = d.monthIndex;
        this.selectedYear = d.year;
        this.updateChart();
      },
    },
  },
  data() {
    return {
      loading: false,
      loadingExport: false,
      selectedMonth: parseInt(moment().format('MM'), 10),
      selectedYear: parseInt(moment().format('yyyy'), 10),
      tempoProcessamentoByShift: [],
      chartExpurgoMensal: {
        grid: [
          {
            show: false,
            left: 10,
            right: 10,
            top: 30,
            bottom: 40,
            borderColor: '#D4D4D4',
          },
        ],
        xAxis: [
          {
            type: 'category',
            axisTick: {
              show: false,
            },
            data: ['Par diurno', 'Par noturno', 'Ímpar diurno', 'Ímpar noturno'],
          },
        ],
        yAxis: [{ show: false }],
        series: [
          {
            name: 'Par diurno',
            type: 'bar',
            barWidth: '60%',
            data: [
              {
                itemStyle: { color: '#21CCA9' },
                value: 0,
              },
              {
                itemStyle: { color: '#209F85' },
                value: 0,
              },
              {
                itemStyle: { color: '#3989BF' },
                value: 0,
              },
              {
                itemStyle: { color: '#73E6CF' },
                value: 0,
              },
            ],
            label: {
              show: true,
              position: 'top',
              formatter: (v) => {
                const h = Math.floor(v.value / 60) ? `${Math.floor(v.value / 60)}h` : '';
                const m = Math.floor(v.value % 60);
                return `${h}${m}m`;
              },
            },
          },
        ],
      },
    };
  },

  methods: {
    onMonthSelection(date) {
      this.selectedMonth = date.monthIndex;
      this.selectedYear = date.year;
      this.updateChart();
    },

    async updateChart() {
      this.loading = true;
      // const colors = ['#21CCA9', '#209F85', '#3989BF', '#73E6CF'];
      await this.getSummaryData();

      this.tempoProcessamentoByShift.forEach((processo) => {
        let index;
        if (processo.oddOrEven === 'odd') {
          if (processo.shift === 'noturno') index = 3;
          else index = 2;
        } else if (processo.shift === 'noturno') index = 1;
        else index = 0;
        const tempoMedioMin = moment.duration(parseInt(processo.tempoMedio, 10)).asMinutes();
        this.chartExpurgoMensal.series[0].data[index].value = tempoMedioMin;
      });
      this.loading = false;
    },

    async getSummaryData() {
      const selectedDate = moment()
        .month(this.selectedMonth - 1)
        .year(this.selectedYear);

      try {
        this.tempoProcessamentoByShift = await GenericApi.getWithoutPagination(
          {
            filters: {
              id_unidade: this.unidadeIndicadores,
              initDate: selectedDate.clone().startOf('month').toISOString(),
              endDate: selectedDate.clone().endOf('month').toISOString(),
              tipoProcesso: 'expurgo',
            },
          },
          'home/tempoProcessamentoGroupedByShift',
        );
        return true;
      } catch (error) {
        let errorMessage = 'Ocorreu um problema ao recuperar os dados relativos aos procedimentos de ciclo';
        if (
          error.response
          && error.response.data
          && error.response.data.error
          && error.response.data.error.errorMessage
        ) {
          errorMessage = error.response.data.error.errorMessage;
        }

        await swal({
          title: 'Erro',
          text: errorMessage,
          icon: 'error',
          button: 'Continuar...',
        });
        return false;
      }
    },

    minutesToHourMinutes(min) {
      if (!min) return '0h';
      const hours = Math.floor(min / 60);
      const minutes = Math.floor(min % 60);
      const hoursString = hours ? `${hours}h` : '';
      const minutesString = minutes ? `${minutes}m`.padStart(3, '0') : '';
      return `${hoursString}${minutesString}`;
    },

    async exportData() {
      this.loadingExport = true;
      const selectedDate = moment()
        .month(this.selectedMonth - 1)
        .year(this.selectedYear);

      const filters = {
        id_unidade: this.unidadeIndicadores,
        initDate: selectedDate.clone().startOf('month').toISOString(),
        endDate: selectedDate.clone().endOf('month').toISOString(),
        tipoProcesso: ['expurgo'],
      };
      const exportedData = await this.getExportedData(
        'home/tempoProcessamentoPlantao/export',
        filters,
        'Erro ao recuperar dados do expurgo para exportação',
      );
      if (!exportedData) {
        this.loadingExport = false;
        return;
      }
      const processosExported = exportedData.map((processo) => {
        const data_processamento = moment(processo.data_processamento);
        const data_finalizacao = moment(processo.data_finalizacao);
        const tempoProcessamento = data_finalizacao.diff(data_processamento, 'minutes');
        const { vouchers_inicio } = processo;
        let voucher_recebimento;
        let voucher_transferencia;
        if (vouchers_inicio) {
          voucher_recebimento = vouchers_inicio.find((voucher) => voucher.tipo === 'recebimento');
          voucher_transferencia = vouchers_inicio.find((voucher) => voucher.tipo === 'transferenciaExpurgo');
        }
        processo.evenOrOddDay = processo.evenOrOddDay === 'odd' ? 'ímpar' : 'par';
        processo.Turno = `${processo.Turno} - ${processo.evenOrOddDay}`;
        delete processo.evenOrOddDay;
        delete processo.vouchers_inicio;
        return {
          ...processo,
          data_processamento: data_processamento.format('DD/MM/YYYY HH:mm:ss'),
          data_finalizacao: data_finalizacao.isValid()
            ? data_finalizacao.format('DD/MM/YYYY HH:mm:ss')
            : '-',
          'Tempo Processamento': data_finalizacao.isValid() ? this.minutesToHourMinutes(tempoProcessamento) : '-',
          Voucher: voucher_recebimento && `R${voucher_recebimento.numero}`,
          // eslint-disable-next-line quote-props
          'Transferência': voucher_transferencia && `T${voucher_transferencia.numero}`,
        };
      });
      const fileName = `Expurgo ${selectedDate.format('MMMM')}`;
      this.createXlsx(processosExported, fileName);
      this.loadingExport = false;
    },
  },

  mounted() {
    this.updateChart();
  },
};
</script>
